export const initMatchImageHeight = () => {
    let previousHeight = null;
    let resizeTimeout = null;
    const imageElement = document.querySelector('.m-stage__post .m-stage__image img');
    const formElement = document.querySelector('.c-form__aside .form-step[data-step="1"]');
    function matchImageHeight() {
        if (imageElement && formElement) {
            const formHeight = formElement.offsetHeight;
            const padding = 64;
            if (window.innerWidth <= 1024) {
                imageElement.style.height = '';
                formElement.style.height = '';
                previousHeight = null;
            }
            else if (formHeight > 0 && previousHeight !== formHeight) {
                imageElement.style.height = `${formHeight + padding}px`;
                previousHeight = formHeight;
            }
        }
    }
    matchImageHeight();
    window.addEventListener('resize', () => {
        if (resizeTimeout)
            clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(matchImageHeight, 100);
    });
    document.addEventListener('click', (e) => {
        const target = e.target;
        if (target.matches('.navigate-previous') || target.matches('[data-step="1"]')) {
            if (imageElement && formElement) {
                imageElement.style.height = '';
                formElement.style.height = '';
                previousHeight = null;
            }
            setTimeout(matchImageHeight, 0);
        }
    });
};
